export default __webpack_public_path__ + "static/media/404.98229b59.svg";